const APP_DEEP_LINK = 'swiftlane://open';
const FALLBACK_DELAY_MS = 2500;

/**
 * Platform detection via user agent.
 * Used to route users: iOS -> App Store / app, Android -> Play Store / app, Desktop -> stay.
 */
function isIOS() {
  if (typeof navigator === 'undefined') return false;
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
}

function isAndroid() {
  if (typeof navigator === 'undefined') return false;
  return /Android/.test(navigator.userAgent);
}

function isIOSSafari() {
  if (typeof navigator === 'undefined') return false;

  const ua = navigator.userAgent || '';
  const isIOSDevice =
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isWebKit = /WebKit/.test(ua);
  const isOtherIOSBrowser = /CriOS|FxiOS|EdgiOS|OPiOS/.test(ua);

  return isIOSDevice && isWebKit && !isOtherIOSBrowser;
}

function isDesktop() {
  return !isIOS() && !isAndroid();
}

/**
 * Returns the URL to redirect to based on device (for direct navigation).
 * Use this when you want a simple link without "try app first" behavior.
 */
export function getAppRedirectUrl({ appStoreUrl, googlePlayUrl, desktopUrl }) {
  if (isIOS()) return appStoreUrl;
  if (isAndroid()) return googlePlayUrl;
  return desktopUrl || (typeof window !== 'undefined' ? window.location.href : '/');
}

/**
 * Handles "Get the app" click with smart routing:
 * - Desktop: stay on page or go to desktopUrl
 * - iOS: try swiftlane://open first, fallback to App Store after delay
 * - Android: try swiftlane://open first, fallback to Play Store after delay
 */
export function handleAppRedirectClick({ appStoreUrl, googlePlayUrl, desktopUrl }) {
  if (isDesktop()) {
    const url = desktopUrl || (typeof window !== 'undefined' ? window.location.href : '/');
    if (url && url !== window?.location?.href) {
      window.location.href = url;
    }
    return;
  }

  if (isIOS()) {
    window.location.href = APP_DEEP_LINK;
    setTimeout(() => {
      if (document.visibilityState === 'visible') {
        window.location.href = appStoreUrl;
      }
    }, FALLBACK_DELAY_MS);
    return;
  }

  if (isAndroid()) {
    window.location.href = APP_DEEP_LINK;
    setTimeout(() => {
      if (document.visibilityState === 'visible') {
        window.location.href = googlePlayUrl;
      }
    }, FALLBACK_DELAY_MS);
  }
}

export { isIOS, isAndroid, isDesktop, isIOSSafari };
